import {
  GET_COMPANY,
  GET_COMPANY_BY_ID,
  GET_PAYMENT_TRANSACTION_DETAILS,
  GET_PAYMENT_TYPE,
} from "../constants/index";

export const common = (state = { companylist: [], getcompanybyid: {}, paymenttransactiondetails: {}, paymenttypelist: {} }, action) => {
  switch (action.type) {
    case GET_COMPANY:
      return { ...state, companylist: action.companylist };
    case GET_COMPANY_BY_ID:
      return { ...state, getcompanybyid: action.getcompanybyid };
    case GET_PAYMENT_TRANSACTION_DETAILS:
      return { ...state, paymenttransactiondetails: action?.paymenttransactiondetails };
    case GET_PAYMENT_TYPE:
      return { ...state, paymenttypelist: action?.paymenttypelist };
    default:
      return state;
  }
};
